<template>
    <div class="phd-risk-calculator">
        <div class="container" v-if="!mainScreen">
           <div class="h3 mt-4">You entered age {{ userAgeValue}}</div>
            <div class="row">
                <div class="col-12 h-100">
                    <form @submit.prevent="hcmCalculatorFormula">
                        <!-- <h2> Hypertrophic Cardiomyopathy - Sudden Cardiac Death Risk Calculator</h2> -->
                        <div class="form-row mb-4 align-items-center">
                          <div class="col-12">
                            <div class="col-6 pl-0 float-left"> 
                              <label for="la-size" class="col-form-label">
                                <span class="abbr" aria-label="Left atrium">
                                  <p title="Left atrium">{{laSizeLabel}}</p>
                                </span>
                               
                                </label> 
                                    <input type="text" class="form-control"
                                    id="la-size" placeholder="28 to 67" v-model:value.number="lasize_range.value"
                                    @input="handleUpperInput('lvpwd_mm')"  @blur="validateLasize" aria-describedby="mm-value" />
                                <p class="text-danger errorMessage" role="alert" v-if="isLasizeValidate"> LA Size must be between 28 and 67 mm</p>
                                <p class="text-danger requiredMessage" role="alert" v-if="isLasizeRequired">LA Size must be between 28 and 67 mm</p>
                                <p class="toolTip mt-3 help-width" role="alert" v-if="!lasizeToolTip">{{ laSizeHelpText }}</p>
                            </div>
                            <div class=" float-left clearfix lower"> 
                              <span class="float-left">mm</span> 
                              <a aria-label="tool tip for Left atrium diameter size" class="ml-4 icon" @click="lasizeToolTip = !lasizeToolTip" key="lasize-input">i</a>
                            </div>
                            </div>
                        </div>

                        <div class="form-row mb-4 align-items-center">
                          <div class="col-12">
                            <div class="col-6 pl-0 float-left"> 
                              <label for="max-lvot" class="col-form-label"><span class="abbr"
                                        aria-label="Maximal left ventricular outflow tract gradient"><p
                                            title="Maximal left ventricular outflow tract gradient">{{ maxLvotGradientLabel }}</p></span></label>
                                            <input type="text" class="form-control"
                                    id="max-lvot" placeholder="2 to 154" v-model:value.number="maxlvot_range.value"
                                    @input="handleUpperInput('la_systole_mm')" @blur="validateMaxlovt" aria-describedby="mmHg-value" />
                                <p class="text-danger errorMessage" role="alert" v-if="isMaxlovtValidate">Max LVOT Gradient must be between 2 and 154 mmHg</p>
                                <p class="text-danger requiredMessage" role="alert" v-if="isMaxlvotRequired">Max LVOT Gradient must be between 2 and 154 mmHg</p>
                                <p class="toolTip mt-3 help-width" role="alert" v-if="!maxlvotToolTip">{{maxLvotGradientHelpText}} </p>
                            </div>
                            <div class=" float-left clearfix lower"> 
                              <span class="abbr float-left"> 
                                <span id="mmHg-value" aria-label="millimetre of mercury " title="millimetre of mercury ">mmHg</span> 
                                </span> 
                                <a aria-label="tool tip for Left ventricular outflow tract obstruction" class="ml-4 icon" @click="maxlvotToolTip = !maxlvotToolTip" key="maxlvot-input">i</a>
                            </div>
                            </div>
                        </div>

                        <div class="form-row mb-4 align-items-center">
                            <div class="col-12">
                              <div class="col-6 pl-0 float-left">
                              <label for="mlvwt" class="col-form-label text-uppercase">
                                <span class="abbr">
                                  <p aria-label="Maximal left ventricular wall thickness"
                                  title="Maximal left ventricular wall thickness">{{mlvwtLabel}}
                                  </p>
                                </span>
                              </label>
                              <input 
                                type="text" class="form-control" id="mlvwt" 
                                placeholder="10 to 35" 
                                v-model:value.number="mlvwt_range.value"
                                @blur="validateMlvwt" 
                                aria-describedby="mm-value" 
                                 @input="handleUpperInput('ivsd_mm')"
                              />
                                  <p class="text-danger errorMessage" role="alert" v-if="isMlvwtValidate"> MLVWT must be between 10 and 35 mm.</p>
                                  <p class="text-danger requiredMessage" role="alert" v-if="isMlvwtRequired"> MLVWT must be between 10 and 35 mm.</p>
                                  <p class="toolTip mt-3 help-width" role="alert" v-if="!mlvwtToolTip">{{mlvwtHelpText}}</p>
                              </div>
                              <div class="float-left clearfix lower">
                              <p class="float-left"> 
                                <span id="mm-value" aria-label="millimetre" title="millimetre">mm</span> 
                              </p> 
                              <a aria-label="tool tip for Maximal left ventricular wall thickness" class="ml-4 icon" @click="mlvwtToolTip = !mlvwtToolTip" key="mlvwt-input">i</a>
                              </div>
                            </div>
                        </div>
                       
                      
                        <fieldset class=" mt-5">
                            <legend class="sr-only">Risk Factors for Sudden Cardiac Death</legend>
                            <div class="form-group row">
                                <div class="col-4 col-form-label text-uppercase"> <span class="abbr"> <span
                                            id="abbrfhscd" aria-label="Family History of Sudden Cardiac Death"
                                            title="Family History of Sudden Cardiac Death">{{fhscdLabel}}</span> </span></div>
                                <div class="col-8 pr-2">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                            for="fhscd_no"> <input type="radio" name="fhscd" id="fhscd_no"
                                                autocomplete="off" v-model.number="fhscd_pick" value="0" checked
                                                aria-describedby="abbrfhscd" /> No </label> <label for="fhscd_yes"
                                            class="ml-4"> <input type="radio" name="fhscd" id="fhscd_yes"
                                                autocomplete="off" v-model.number="fhscd_pick" value="1"
                                                aria-describedby="abbrfhscd" /> Yes </label> 
                                                <a aria-label="tool tip for Family History of Sudden Cardiac Death" class="ml-4 icon"
                                            @click="fhscdToolTip = !fhscdToolTip" key="fhscd-input">i</a></div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <p class="toolTip help-width" role="alert" v-if="!fhscdToolTip" v-html="fhscdHelpText"></p>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-4 col-form-label text-uppercase"> <span class="abbr"> <span
                                            id="abbrnsvt" aria-label="Non-sustained ventricular tachycardia"
                                            title="Non-sustained ventricular tachycardia">{{nsvtLabel}}</span> </span></div>
                                <div class="col-8 pr-2">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                            for="nsvt_no"> <input type="radio" name="nsvt" id="nsvt_no"
                                                autocomplete="off" v-model.number="nsvt_pick" value="0" checked
                                                aria-describedby="abbrnsvt" /> No </label> <label for="nsvt_yes"
                                            class="ml-4"> <input type="radio" name="nsvt" id="nsvt_yes"
                                                autocomplete="off" v-model.number="nsvt_pick" value="1"
                                                aria-describedby="abbrnsvt" /> Yes </label> <a aria-label="tool tip for Non-sustained ventricular tachycardia" class="ml-4 icon"
                                            @click="nsvtToolTip = !nsvtToolTip" key="nsvt-input">i</a></div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <p class="toolTip help-width" role="alert" v-if="!nsvtToolTip" v-html="nsvtHelpText"></p>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-4 col-form-label"> {{usLabel}}</div>
                                <div class="col-8 pr-2">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                            for="unexSy_no"> <input type="radio" name="unexSy" id="unexSy_no"
                                                autocomplete="off" v-model.number="unexSy_pick" value="0" checked />
                                            No </label> <label for="unexSy_yes" class="ml-4"> <input type="radio"
                                                name="unexSy" id="unexSy_yes" autocomplete="off"
                                                v-model.number="unexSy_pick" value="1" /> Yes </label> <a
                                            aria-label="tool tip for Unexplained Syncope" class="ml-4 icon" @click="unexSyToolTip = !unexSyToolTip" key="unexsy-input">i</a></div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <p class="toolTip help-width" role="alert" v-if="!unexSyToolTip" v-html="usHelpText"></p>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-4 col-form-label"> <span class="abbr"> <span id="abbref"
                                            aria-label="Ejection fraction"
                                            title="Ejection fraction" v-html="efLabel"></span>:</span>
                                   
                                </div>
                                <div class="col-8 pr-2">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                            for="ef50_no"> <input type="radio" name="ef50" id="ef50_no"
                                                autocomplete="off" v-model.number="ef50_pick" value="0" checked
                                                aria-describedby="abbref" /> No </label> <label for="ef50_yes"
                                            class="ml-4"> <input type="radio" name="ef50" id="ef50_yes"
                                                autocomplete="off" v-model.number="ef50_pick" value="1"
                                                aria-describedby="abbref" /> Yes </label> <a aria-label="tool tip for Ejection fraction" class="ml-4 icon"
                                            @click="ef50ToolTip = !ef50ToolTip" key="ef50-iput">i</a></div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <p class="toolTip help-width" role="alert" v-if="!ef50ToolTip" v-html="efHelpText"></p>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-4 col-form-label">{{aaLabel}}</div>
                                <div class="col-8 pr-2">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons"> <label
                                            for="apAn_no"> <input type="radio" name="apAn" id="apAn_no"
                                                autocomplete="off" v-model.number="apAn_pick" value="0" checked />
                                            No </label> <label for="apAn_yes" class="ml-4"> <input type="radio"
                                                name="apAn" id="apAn_yes" autocomplete="off"
                                                v-model.number="apAn_pick" value="1" /> Yes </label> <a
                                            aria-label="tool tip for Apical Aneurysm" class="ml-4 icon" @click="apAnToolTip = !apAnToolTip" key="apan-input">i</a></div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <p class="toolTip help-width" role="alert" v-if="!apAnToolTip" v-html="aaHelpText">
                                    </p>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-4 col-form-label"> <span class="abbr"> <span
                                            aria-label="Late gadolinium enhancement" id="abbr-elge"
                                            title="Late gadolinium enhancement">{{ lgeLabel }}</span></span>
                                </div>
                                <div class="col-8 pr-2">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons"> 
                                      <label for="elge_no"> <input type="radio" name="elge" id="elge_no"
                                                autocomplete="off" v-model.number="elge_pick" value="0" checked
                                                aria-describedby="abbr-elge" /> No 
                                         </label> 
                                      <label for="elge_yes" class="ml-4"> 
                                        <input type="radio" name="elge" id="elge_yes" autocomplete="off" v-model.number="elge_pick" value="1"
                                                aria-describedby="abbr-elge" /> Yes 
                                      </label> 
                                      <a aria-label="tool tip for Extensive Late gadolinium enhancement" class="ml-4 icon"
                                            @click="elgeToolTip = !elgeToolTip" key="elge-input">i</a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-8">
                                    <p class="toolTip help-width" role="alert" v-if="!elgeToolTip" v-html="lgeHelpText"></p>
                                </div>
                            </div>
                        </fieldset>
                        <div class="c-hero-card__container col-6" v-if="validationModal">
                        <aha-modal :interval="0" id="validationModal" ref="validationModal" class="c-modal--generic"
                            title="Modal Header" hide-footer centered scrollable>
                            <div class="h3 text-left validation-modal-header" v-html="errorModalHeaderText">
                            </div>
                          
                            <div class="h4 text-left mt-4 ">HCM SCD Score</div>

                            <div>
                                <div class="ml-3 text-left validation-modal-style" v-if="lasize_range.value === ''"> - LA
                                    size field is missing</div>
                                <div class="ml-3 text-left validation-modal-style"
                                    v-else-if="lasize_range.value > 67 || lasize_range.value < 28"> - LA Size must be between 28
                                    and 67 mm.</div>
                            </div>
                            <div>
                                <div class="ml-3 text-left validation-modal-style" v-if="maxlvot_range.value === ''"> - Max
                                    LVOT Gradient field is missing</div>
                                <div class="ml-3 text-left validation-modal-style"
                                    v-else-if="maxlvot_range.value > 154 || maxlvot_range.value < 2"> - Max LVOT Gradient must be
                                    between 2 and 154 mmHg.</div>
                            </div>
                            <div>
                                <div class="ml-3 text-left validation-modal-style" v-if="mlvwt_range.value === ''"> - MLVWT
                                    field is missing</div>
                               
                                <div class="ml-3 text-left validation-modal-style"
                                    v-else-if="mlvwt_range.value> 35 || mlvwt_range.value < 10">- MLVWT must be between 10 and 35 mm</div>
                            </div>


                            <p class="mt-3 h6 text-left" v-html="errorModalFooterText"></p>
                            <div class="d-flex justify-content-between mt-4">
                                <div class="btn btn-outline-danger" @click="validationBack">Back</div>
                                <div class="btn btn-primary" @click="hcmCalculatorFormula">See Results</div>
                            </div>
                        </aha-modal>
                    </div>
                        <div class="form-group row">
                            <div class="col col-md-12 text-center text-lg-left"> 
                              <input class="btn btn-primary"  @click = "handleBackScreen" type = "button" value="Back"  key="back"/>
                              <a href="#" v-b-modal="'validationModal'" class="btn btn-primary" type="submit"
                                @click="formValidate" value="Calculate" key="submit">Submit</a>
                              <input class="btn btn-outline ml-3" @click="resetForm" type="reset" key="reset"
                                    value="Reset"></div>
                        </div>
                        <div class="d-flex justify-content-between w-100 align-center ">
                            <p class="col-sm-12 col-md-6 c-daily-journey__slide-number mt-3">2 of 3</p>
                            <p class="p col-sm-12 col-md-6 mt-3" v-html = "calculatorVersionText"></p>
                         
                    </div>
                    </form>
                </div>
                
            </div>
        </div>

        <div v-if="isShowModal" class="mt-4">
            <div class="h4">Estimated risk of SCD at 5 years (%) for age {{ userAgeValue}}</div>
            <div class="p" v-html="riskHeaderText"></div>
        <div class="row flex-column justify-content-center align-content-center mt-4 ">
          
          <div class="col-12 w-50 mx-auto c-hero-card__container mb-4 d-flex justify-content-center mt-4"  v-if="hcmScdCalculatorResultValidatoin">
                <div class="custom-modal-cal" >
                    <p class="c-hero-card__heading d-flex justify-content-center text-center h4">HCM SCD Score</p>
                    <p class="c-hero-card__subheading h1 d-flex justify-content-center font-weight flex-column" v-html="risk.value + '%'" ></p>
                    
                    <a href="#" v-b-modal="'riskSCD'" class="c-cta c-cta--arrow h-theme--red custom-cal-link">{{ hcmScdScoreLabel }}</a>
                </div> 
                <aha-modal :interval="0" id="riskSCD" ref="riskSCD" class="c-modal--generic"
            title="Modal Header" hide-footer centered scrollable>
            <aha-transition-group class="c-hero-card-snackable-full-quiz">
                <aha-transition-group-form :error-step-key=7 url="/aha-service/grfw/Quiz"
                    name="Strip Down">
                    <template slot-scope="formCtrl">
                        <div class="c-hero-card-snackable-full-quiz align-self-start">
                            <div class="" aria-live="polite">
                                <aha-transition-step class="c-hero-card-snackable__transition"
                                    :step-key="1">
                                  <div class = "text-left" v-html="hcmScdScoreDescription"></div>                                
                                </aha-transition-step>
                            </div>
                        </div>                      
                    </template>
                </aha-transition-group-form>
            </aha-transition-group>
        </aha-modal>
            </div>
            <div class="p mt-4 mb-4 ml-3" v-html = "resultGuidelineTextAdult"> </div>
            <div class="d-flex justify-content-left align-center mt-4 h4">
            {{patientSelectionLabel}}
        </div>
        <div class="d-flex justify-content-center align-center mt-4">
          <div v-html="hcmRecommendationDescription"></div>
          
        </div>
           <div class="col-12 w-50 mx-auto c-hero-card__container  mt-4 d-flex justify-content-center" v-if="hcmScdCalculatorResultValidatoin">
                <div class="custom-modal-cal" >
                    <p class="c-hero-card__heading d-flex h4">{{ hcmScdRecommendationLabel }}</p>
                    <p class=" h5 d-flex justify-content-center custom-recommedation-text" v-html="recommendation"></p>
                  </div>
                  
            </div>

        </div>
       
        <p class="c-daily-journey__slide-number  d-flex justify-content-center mt-4">3 of 3</p>
        <div class = "d-flex justify-content-center mt-3">
        <button type="button" class="p-0 my-4 bg-white border-0 custom-start-over" @click = "handleReload">
            <img src="/assets/glyphs/retake-quiz-Icon.svg" /> <span class="text-primary" >Start Over</span>
        </button>
    </div>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      hcmRecommendationDescription: {
            type: String,
            required: true
        },
        patientSelectionLabel: {
            type: String,
            required: true
        },
      riskHeaderText:{
            type: String,
            required: true
        },
      resultGuidelineTextAdult: {
            type: String,
            required: true
        },
      calculatorVersionText: {
            type: String,
            required: true
        },
    userAgeValue: {
      type: String,
      required: true
    },
    handleFourthScreen: Function,
    heightErrorMessage:{
            type: String,
            required: true
        },
        weightErrorMessage:{
            type: String,
            required: true
        },
        laSizeErrorMessage:{
            type: String,
            required: true
        },
        maxLvotGradientErrorMessage:{
            type: String,
            required: true
        },
        mlvwtErrorMessage:{
            type: String,
            required: true
        },
        isdErrorMessage:{
            type: String,
            required: true
        },
        sexLabel:{
            type: String,
            required: true
        },
        heightLabel:{
            type: String,
            required: true
        },
        weightLabel:{
            type: String,
            required: true
        },
        laSizeLabel:{
            type: String,
            required: true
        },
        maxLvotGradientLabel:{
            type: String,
            required: true
        },
        mlvwtLabel:{
            type: String,
            required: true
        },
        isdLabel:{
            type: String,
            required: true
        },
        gpLabel:{
            type: String,
            required: true
        },
        usLabel:{
            type: String,
            required: true
        },
        nsvtLabel:{
            type: String,
            required: true
        },
        gsLabel:{
            type: String,
            required: true
        },
        efLabel:{
            type: String,
            required: true
        },
        fhscdLabel:{
            type: String,
            required: true
        },
        aaLabel:{
            type: String,
            required: true
        },
        lgeLabel:{
            type: String,
            required: true
        },
        laSizeHelpText:{
            type: String,
            required: true
        },
        maxLvotGradientHelpText:{
            type: String,
            required: true
        },
        mlvwtHelpText:{
            type: String,
            required: true
        },
        isdHelpText:{
            type: String,
            required: true
        },
        gpHelpText:{
            type: String,
            required: true
        },
        usHelpText:{
            type: String,
            required: true
        },
        nsvtHelpText:{
            type: String,
            required: true
        },
        gsHelpText:{
            type: String,
            required: true
        },
        efHelpText:{
            type: String,
            required: true
        },
        fhscdHelpText:{
            type: String,
            required: true
        },
        aaHelpText:{
            type: String,
            required: true
        },
        lgeHelpText:{
            type: String,
            required: true
        },
          //modal Text 
          hcmRiskkidsScoreLabel:{
            type: String,
            required: true
        },

        hcmRiskKidsScoreDescription:{
            type: String,
            required: true
        },
        primacyRiskScoreLabel:{
            type: String,
            required: true
        },

        primacyRiskScoreDescription:{
            type: String,
            required: true
        },
        lvmwtZScoreLabel:{
            type: String,
            required: true
        },

        lvmwtZScoreDescription:{
            type: String,
            required: true
        },
        laDiameterZScoreLabel:{
            type: String,
            required: true
        },

        laDiameterZScoreDescription:{
            type: String,
            required: true
        },
        hcmScdScoreLabel:{
            type: String,
            required: true
        },

        hcmScdScoreDescription:{
            type: String,
            required: true
        },
        prognosticIndexLabel:{
            type: String,
            required: true
        },

        prognosticIndexDescription:{
            type: String,
            required: true
        },
        hcmScdRecommendationLabel: {
            type: String,
            required: true
        },
        hcmScdRecommendationDescription: {
            type: String,
            required: true
        },
        errorModalFooterText: {
            type: String,
            required: true
        },
        errorModalHeaderText: {
            type: String,
            required: true
        },
  },

    data() {
      return {
        isShowModal: false,
        isAgeValidate: false,
        isMlvwtValidate: false,
        isLasizeValidate: false,
        isMaxlovtValidate: false,
        isAgeRequired: false,
        isMlvwtRequired: false,
        isLasizeRequired: false,
        isMaxlvotRequired: false,
        ageToolTip: true,
        mlvwtToolTip: true,
        lasizeToolTip: true,
        maxlvotToolTip: true,
        fhscdToolTip: true,
        nsvtToolTip: true,
        unexSyToolTip: true,
        ef50ToolTip: true,
        apAnToolTip: true,
        elgeToolTip: true,
       
        mlvwt_range: {
          value: "",
          wallThickness: {
            min: 10,
            max: 35,
          },
          requiredMessage: this.mlvwtErrorMessage,
          errorMessage:
            "MLVWT must be between 10 and 35 mm.",
        },
        lasize_range: {
          value: "",
          laDiameter: {
            min: 28,
            max: 67,
          },
          requiredMessage: this.laSizeErrorMessages,
          errorMessage: "LA Size must be between 28 and 67 mm",
        },
        maxlvot_range: {
          value: "",
          lvotGradient: {
            min: 2,
            max: 154,
          },
          requiredMessage: this.mlvwtErrorMessage,
          errorMessage:
            "Max LVOT Gradient must be between 2 and 154 mmHg.",
        },
        fhscd_pick: 0,
        nsvt_pick: 0,
        unexSy_pick: 0,
        ef50_pick: 0,
        apAn_pick: 0,
        elge_pick: 0,
        recommendation: "",
        risk: {
          value: "",
        },
        hcmScdCalculatorResultValidatoin: false,
        validationModal: false,
        mainScreen: false,
       
      };
    },
    methods: {
      validationBack() {
            this.validationModal = false
            this.mainScreen = false
            this.isShowModal = false
        },

      handleUpperInput(inputKey) {
           
            if(inputKey === 'ivsd_mm'){
                this.mlvwt_range.value = this.mlvwt_range.value.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'lvpwd_mm'){
                this. lasize_range.value = this. lasize_range.value.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'la_systole_mm'){
                this.maxlvot_range.value = this.maxlvot_range.value.replace(/[^0-9.]/g, "");
            }

            if(inputKey === 'peak_grad_mmhg'){
                this.peak_grad_mmhg = this.peak_grad_mmhg.replace(/[^0-9.]/g, "");
            }
        },

      handleBackScreen(){
        this.handleFourthScreen()
      },
      handleReload() {
       
            window.location.reload();
        },
      hcmCalculatorFormula() {
        this.isShowModal = true
        this.validationModal = false
            this.mainScreen = true
        const age = this.userAgeValue;
        const mlvwt = this.mlvwt_range;
        const lasize = this.lasize_range;
        const maxlvot = this.maxlvot_range;
        const fhscd = this.fhscd_pick;
        const nsvt = this.nsvt_pick;
        const unexSyncope = this.unexSy_pick;
        const ef50 = this.ef50_pick;
        const aa = this.apAn_pick;
        const elge = this.elge_pick;
  
        let a = 0.01799934 * age;
        let b = 0.15939858 * mlvwt.value - 0.00294271 * mlvwt.value * mlvwt.value;
        let c = 0.0259082 * lasize.value;
        let d = 0.00446131 * maxlvot.value;
        let e = fhscd === 0 ? 0 : 0.4583082;
        let f = nsvt === 0 ? 0 : 0.82639195;
        let g = unexSyncope === 0 ? 0 : 0.71650361;
        let h = mlvwt.value <= 29 ? 0 : 1;
        let i = ef50 === 0 ? 0 : 1;
        let j = null;
        let k = b + c + d + e + f + g - a;
        let l = Math.pow(2.71828183, k);
        let m = Math.pow(0.998, l);
        let risk = 100 * (1 - m);
  
        var elgeYes = elge == 1;
        var aaYes = aa == 1;
        var efYes = i == 1;
        var nsvtYes = f == 0.82639195;
        var fhscdYes = e == 0.4583082;
        var usYes = g == 0.71650361;
        var mlvwtYes = h == 1;
  
        switch (true) {
          //Class 2A: When one parameter AND NSVT AND Extensive LGE = YES
          case elgeYes && nsvtYes && aaYes && efYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%, Apical Aneurysm, and Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("elge, aa, ef & nsvt are yes");
            break;
          case efYes && nsvtYes && elgeYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("elge & nsvt");
            break;
          case aaYes && nsvtYes && elgeYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("elge & nsvt");
            break;
          case fhscdYes && nsvtYes && elgeYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("fhscd, elge, nsvt are yes");
            break;
          case usYes && nsvtYes && elgeYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("US, elge, nsvt are yes");
            break;
          case mlvwtYes && nsvtYes && elgeYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("mlvwt, elge, nsvt are yes");
            break;
          case elgeYes && efYes && aaYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm, EF ≤ 50% and Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("elge,ef,aa are yes");
            break;
          case nsvtYes && efYes && aaYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Apical Aneursym)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("elge,ef,aa are yes");
            break;
  
          //Class 2B(a): When all parameters = NO except for NVST AND Extensive LGE
          case elgeYes && nsvtYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "This patient has 2 risk factors that while individually carry Class 2B indications, having both of these likely represents more risk than having either risk factor in isolation");
            console.log("elge & nsvt");
            break;
  
          //Class 2A: When any parameter AND EXTENSIVE LGE = YES
          case elgeYes && aaYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("switch elge & aa");
            break;
          case elgeYes && efYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50% and Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("elge & ef are yes");
            break;
          case elgeYes && fhscdYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("FHSCD and ELGE are yes");
            break;
          case elgeYes && usYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("Unexplained Syncope and ELGE are yes");
            break;
          case elgeYes && mlvwtYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("MLVWT and ELGE are yes");
            break;
  
          //Class 2A: When any parameter AND NVST = YES
          case nsvtYes && efYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("EF and NSVT are yes");
            break;
          case nsvtYes && aaYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("EF and NSVT are yes");
            break;
          case nsvtYes && fhscdYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("FHSCD and NSVT are yes");
            break;
          case nsvtYes && usYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("Unexplained Syncope and NSVT are yes");
            break;
          case nsvtYes && mlvwtYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("MLVWT and NSVT are yes");
            break;
  
          //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
          case efYes && aaYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm and EF ≤ 50%)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("EF and AA are yes");
            break;
  
          //Class 2B: When all parameters = NO except for NVST OR Extensive LGE
          case nsvtYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)");
            console.log("nsvtYes");
            break;
          case elgeYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Extensive LGE)"),
              (this.recommendation =
                "Based on the SCD risk factors present, this patient has a Class 2B indication for an ICD (may be considered)");
            console.log("elge catch all");
            break;
  
          //Class 2A: When any parameter except for NSVT and Extensive LGE = YES
          case efYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of EF ≤ 50%)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("EF is Yes");
            break;
          case aaYes:
            (this.risk.value =
              risk.toFixed(2) +
              " " +
              "(<em>Nota bene</em>: This estimate may not be accurate in the setting of Apical Aneurysm)"),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("Apical aneurysm is yes");
            break;
          case fhscdYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("fhscd is yes");
            break;
          case usYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("Unexplained Syncope is Yes");
            break;
          case mlvwtYes:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the SCD Risk factors present, this patient has a Class 2A indication for ICD (is reasonable)");
            console.log("mlvwt is yes");
            break;
          default:
            (this.risk.value = risk.toFixed(2)),
              (this.recommendation =
                "Based on the absence of risk factors, this patient does not have an indication for an  <span class='abbr' title='Implantable Cardioverter Defibrillator'><abbr title='Implantable Cardioverter Defibrillator'>ICD</abbr></span>  (Class 3 – No Benefit)");
            console.log("all no");
            break;
        }
      },
  
     
  
      validateMlvwt() {
       if(this.mlvwt_range.value === ""){
          this.isMlvwtRequired = true
          this.isMlvwtValidate = false
       } else if(this.mlvwt_range.value >= this.mlvwt_range.wallThickness.min && this.mlvwt_range.value <= this.mlvwt_range.wallThickness.max){
          this.isMlvwtValidate = false
          this.isMlvwtRequired = false
       } else {
        this.isMlvwtValidate = true
        this.isMlvwtRequired = false
       }
        
      },
  
      validateLasize() {
        if(this.lasize_range.value=== ''){
         
          this.isLasizeValidate = false;
          this.isLasizeRequired = true;
        }else if (
          this.lasize_range.value >= this.lasize_range.laDiameter.min &&
          this.lasize_range.value <= this.lasize_range.laDiameter.max
        ) {
          this.isLasizeValidate = false;
          this.isLasizeRequired = false;
        } else {
          this.isLasizeValidate = true;
          this.isLasizeRequired = false;
          
        } 
      },
  
      validateMaxlovt() {
        if(this.maxlvot_range.value === ""){
          this.isMaxlvotRequired = true
          this.isMaxlovtValidate =false
        }
        else if (
          this.maxlvot_range.value >= this.maxlvot_range.lvotGradient.min &&
          this.maxlvot_range.value <= this.maxlvot_range.lvotGradient.max
        ) {
          this.isMaxlvotRequired = false
          this.isMaxlovtValidate =false
        } else {
          this.isMaxlvotRequired = false
          this.isMaxlovtValidate =true
        }
      },
  
      formValidate(e) {
       
  
        // if (this.mlvwt_range.value == "") {
        //   this.isMlvwtRequired = true;
        //   console.log("number not entered");
        //   e.preventDefault();
        // } else {
        //   this.isMlvwtRequired = false;
        //   console.log("number entered");
        // }
  
        // if (this.lasize_range.value == "") {
        //   this.isLasizeRequired = true;
        //   console.log("number not entered");
        //   e.preventDefault();
        // } else {
        //   this.isLasizeRequired = false;
        //   console.log("number  entered");
        // }
  
        // if (this.maxlvot_range.value == "") {
        //   this.isMaxlvotRequired = true;
        //   console.log("number not entered");
        //   e.preventDefault();
        // } else {
        //   this.isMaxlvotRequired = false;
        //   console.log("number entered");
        // }

        if (this.lasize_range.value === '') {
          console.log ('Bharat')
                this.hcmScdCalculatorResultValidatoin = false
            } else if (this.lasize_range.value > 67 || this.lasize_range.value < 28) {
              console.log ('1st satement false')
                this.hcmScdCalculatorResultValidatoin = false
                
            }

            else if (this.maxlvot_range.value === '') {
                this.hcmScdCalculatorResultValidatoin = false
            } else if (this.maxlvot_range.value  > 154 || this.maxlvot_range.value  < 2) {
                this.hcmScdCalculatorResultValidatoin = false
               
            }
            else if (this.mlvwt_range.value === '') {
                this.hcmScdCalculatorResultValidatoin = false
            } else if (this.mlvwt_range.value  > 35 || this.mlvwt_range.value  < 10) {
                this.hcmScdCalculatorResultValidatoin = false
               
            }

            else {
                this.hcmScdCalculatorResultValidatoin = true
            }

            if(this.hcmScdCalculatorResultValidatoin) {
              this.validationModal = false
                this.isShowModal = true
                this.mainScreen = true
                this.hcmCalculatorFormula()
            } else {
              this.validationModal = true
            }
           
      },
  
      resetForm() {
      
        this.mlvwt_range.value = "";
        this.lasize_range.value = "";
        this.maxlvot_range.value = "";
        this.fhscd_pick = 0;
        this.nsvt_pick = 0;
        this.unexSy_pick = 0;
        this.ef50_pick = 0;
        this.apAn_pick = 0;
        this.elge_pick = 0;
        this.risk.value = "";
        this.recommendation = "";
        this.isAgeValidate = false;
        this.isMlvwtValidate = false;
        this.isLasizeValidate = false;
        this.isMaxlovtValidate = false;
        this.isAgeRequired = false;
        this.isMlvwtRequired = false;
        this.isLasizeRequired = false;
        this.isMaxlvotRequired = false;
        this.ageToolTip = true;
        this.mlvwtToolTip = true;
        this.lasizeToolTip = true;
        this.maxlvotToolTip = true;
        this.fhscdToolTip = true;
        this.nsvtToolTip = true;
        this.unexSyToolTip = true;
        this.ef50ToolTip = true;
        this.apAnToolTip = true;
        this.elgeToolTip = true;
      },
    },
  };
  </script>
  
  
  <style lang="scss" scoped>
  @import "~@/sass/base";
  
  .custom-recommedation-text {
    font-weight: normal !important;
  }

  .custom-cal-link {
    width: 270px;
    margin-left: -20px;
    text-decoration: none;
    text-align: left;
}

.custom-cal-link::after {
    font-size: 10px;
    margin-top:-5px;
}

  .custom-modal-cal {
    width: 310px !important;
    border-top:6px solid #ed0a22;
    background: #fff;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.2);
    padding: 48px 18px 36px;
    z-index: 2;
}

.custom-start-over {
    border: 1px solid #ed0a22 !important;
    padding: 10px 12px !important;
    border-radius: 50px;

}

.custom-modal-cal p {
   color: black !important;
   font-weight: 600;
   display: flex !important;
    flex-direction: column !important;
    text-align: center !important;
}


  textarea.form-control,
  .c-aha-form textarea {
    padding: 10px;
    min-height: 100px;
  }
  
  .lower {
    margin-top: 45px;
  }
  
  @include media-breakpoint-up(sm) {
    .lower {
      margin-top: 50px;
    }
  }
  
  a.icon {
    width: 30px;
    height: 30px;
    background: #ed0a22;
    border-radius: 50%;
    border: thin solid #ed0a22;
    color: #fff !important;
    font-weight: bold;
    display: inline-flex;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  a.icon:hover {
    color: #fff;
  }
  
  #risk,
  #recommendation,
  .toolTip {
    background-color: #e9ecef;
    opacity: 1;
    padding: 1rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-clip: padding-box;
    border: 1px solid #c4cacf;
    border-radius: 2px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .validation-modal-style {
    color: #ed0a22;
    font-weight: 600;
    font-size: 12px;
}

.validation-modal-header {
  width: fit-content;
}

.help-width {
  width:610px;
}

.modal.show .modal-dialog-centered .modal-content {
  overflow: hidden;
  word-wrap: break-word;
}

@media (min-width: 768px) { /* For md (medium) devices and up */
  .help-width {
  width:610px;
}
}

@media (max-width: 767.98px) { /* For sm (small) devices and below */
  .help-width {
  width:300px;
}
}

  </style>


// WEBPACK FOOTER //
// demo/pages/components/hcm-scd-calculator.vue